import React, { useEffect, useState } from 'react';
import { useTranslate } from '../components/TranslationText';
import { useSelector } from 'react-redux';
import axios from "../axios/axiosUmbraco";
import Loader from '../components/Loader';
import ActionButton from '../components/ActionButton';
import FilterButton from '../components/FilterButton';
import Lightbox from 'react-18-image-lightbox';
import EducationalFilter from '../components/EducationalFilter';
import ComingSoon from '../components/ComingSoon';
import { showFirst12Words, showFirst22Words } from '../helper/showFirstSixWords';
import { translateMonthToArabic } from '../helper/translateDayToArabic';
import CoursesFilter from '../components/CoursesFilter';
import { Link, useNavigate } from 'react-router-dom';
import axiosInstance from '../axios/axios';
import { formatDate } from '../helper/formatDate';
import { formatDateArray } from '../helper/formatDateArray';

const BaseURL = process.env.REACT_APP_BASE_URL;
const fetch = process.env.REACT_APP_UMBRACO_EDUCATIONAL_PAGE_ID;
const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

export default function CoursesNewPage() {
    const { translate } = useTranslate();
    const { currentLanguage } = useSelector((state) => state.studBookSlice);
    const navigate = useNavigate();

    const [courses, setCourses] = useState([]);
    const [total, setTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);



    async function getdata(title = "", startDate = "", endDate = "", isFilter = false) {
        setIsLoading(true);
        const res = await axiosInstance.get(`/courses/getcourses?title=${title}&startDate=${startDate}&endDate=${endDate}`);

        const formattedData = res.data?.result?.map((item) => ({
            id: item?.id,
            title: item?.title ?? '',
            subtitle: item?.subtitle ?? '',
            link: item?.link ?? '',
            image: item?.image ?? '',
            startDate: item?.startDate ?? '',
            dipslayDate: formatDateArray(item?.startDate) ?? '',
            endDate: item?.endDate ?? '',
            isOpenedToRegister: item?.isOpenedToRegister ?? false,
            termsList: JSON.stringify(item?.termsList) ?? '',

        }));



        setCourses(formattedData);
        if (!isFilter) {
            setTotal(res.data?.result?.length ?? 0);
        }
        setIsLoading(false);
    }

    useEffect(() => {
        getdata();
    }, [currentLanguage]);

    const handleFilter = (filters) => {
        getdata(filters?.coursTitle, filters?.DateFrom ?? '', filters?.DateTo ?? '', true);
    };

    return (
        <>
            {isLoading && <Loader />}
            {total === 0 && !isLoading && <ComingSoon />}
            {total > 0 && (
                <div className="container-fluid px75">
                    <div className="row m0 ">
                        <h2 className="col-sm-12 p0 bold rtl capatalise">
                            {translate('web.courses', 'Courses')}
                        </h2>
                    </div>
                    <div className="row m0 rtl">
                        {windowWidth <= 970 && (
                            <div className="col-md-2 col-sm-3 text-center">
                                <FilterButton onClick={() => setShowFilter(!showFilter)} />
                            </div>
                        )}
                        <div className="col-lg-3 col-md-3 col-sm-12 NewsFilterContainer" style={{ display: windowWidth > 970 || showFilter ? 'block' : 'none' }}>
                            <CoursesFilter onSubmit={handleFilter} />
                        </div>

                        <div className="col-lg-9 col-md-9 col-sm-12">
                            <div className="row m0 rtl">
                                {courses.length > 0 ? (
                                    courses.map((item, index) => (
                                        <>
                                            <div className="col-lg-4 col-md-6 px-5px col-sm-12" key={index} style={{ position: "relative" }}>
                                                <div
                                                    onClick={(e) => {
                                                        if (!!item?.isOpenedToRegister) {
                                                            navigate(`/courseEnrollment?Id=${item?.id}`, {
                                                                state: !item?.isOpenedToRegister ? item?.link : {},
                                                            });
                                                        } else {

                                                            if (!!item?.link && item?.link != '-') {

                                                                navigate(`/courseDetails?Id=${item?.id}&name=${item?.title}`, {
                                                                    state: !item?.isOpenedToRegister ? { link: item?.link } : {},
                                                                });
                                                            } else {

                                                                e.preventDefault();
                                                            }

                                                        }
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <div style={{ borderRadius: 5, minHeight: 475, margin: '5px 0', overflow: 'hidden' }}>
                                                        <div style={{ position: 'relative' }}>
                                                            <div style={{ width: '100%', maxHeight: 200, overflow: 'hidden' }}>
                                                                <img src={item?.image} className="card-img-top newsImage bg-gray" alt="..." />
                                                            </div>
                                                            {/* <div className='playButtonContainer'><i className="fa-regular fa-circle-play"></i></div> */}
                                                        </div>
                                                        <div className="card-body px-0">
                                                            <h5 className="card-title px-0 newsPageNewsTitle">{showFirst12Words(item?.title)}</h5>
                                                            <p className="card-text px-0 newsPageNewsDescription">{showFirst22Words(item?.subtitle)}</p>
                                                            <div className="newsPageNewsDateContainer">
                                                                <div className="newsPageNewsDay">{item?.dipslayDate[0]}</div>
                                                                <div className="newsPageDateSpacer"></div>
                                                                <div className="newsPageMonthAndYear">
                                                                    <span>{translateMonthToArabic(item?.dipslayDate[1], currentLanguage == 'en' ? 'en-US' : 'ar-AE')}</span>
                                                                    <span>{item?.dipslayDate[2]}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ))
                                ) : (
                                    <div className="text-center bold color-eahsred">
                                        {translate('web.nodataFound', 'No News Found with Your Filter Parameters')}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
